import React from 'react';
import { ethosPrinciples, landlordBenefits, ethosImage } from '../mock';

export default function Ethos() {
  return (
    <section id="ethos" className="relative py-24 md:py-36 border-t border-white/5">
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage: `url(${ethosImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f0f10] via-[#0f0f10]/95 to-[#0f0f10] pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-px bg-[#e4cfaf]" />
          <span className="uppercase text-[11px] tracking-[0.28em] text-[#e4cfaf]/90">Our Ethos</span>
        </div>
        <h2 className="serif text-white text-4xl md:text-6xl leading-[1.05] max-w-4xl">
          Built on four principles that <span className="italic-serif">put landlords first.</span>
        </h2>

        <div className="mt-16 md:mt-20 grid md:grid-cols-2 gap-x-16 gap-y-12">
          {ethosPrinciples.map((p) => (
            <div key={p.roman} className="flex gap-6 md:gap-8 border-t border-white/10 pt-8">
              <div className="serif text-[#e4cfaf] text-3xl md:text-4xl min-w-[3rem]">{p.roman}</div>
              <div>
                <h3 className="serif text-white text-2xl md:text-3xl mb-3">{p.title}</h3>
                <p className="text-white/60 leading-relaxed">{p.body}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 md:mt-32">
          <h3 className="serif text-white text-3xl md:text-4xl mb-10">Benefits for landlords</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {landlordBenefits.map((b) => (
              <div key={b.title} className="bg-[#0f0f10] p-8 md:p-9 tilt-card">
                <h4 className="serif text-white text-xl md:text-[22px] mb-3">{b.title}</h4>
                <p className="text-white/60 text-[15px] leading-relaxed">{b.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
